export const WORKS_ROUTE = '/works';
export const ALL_WORKS_ROUTE = '/all-works';
export const MOVERS_SALARY_ROUTE = '/movers-salary';
export const SCHEDULE_ROUTE = '/schedule';
export const MY_WORKS_ROUTE = '/my-works';
export const SINGLE_WORK_ROUTE = `${MY_WORKS_ROUTE}/:id`;
export const COMPLETED_ROUTE = '/completed';
export const COMPLETED_WORK_ROUTE = `/${COMPLETED_ROUTE}/:id`;
export const LOGIN = '/';
export const PRICES_ROUTE = '/prices';
export const USERS_ROUTE = '/users';
export const SEARCH_ROUTE = '/search';
export const SALES_SALARY_ROUTE = '/sales-salary';